import React, { useState, useEffect } from "react";
import { YhBox } from "@/components/YhBox";
import { Table, Button, message, Checkbox } from "antd";
import { ColumnsType, TablePaginationConfig } from "antd/lib/table";
import useGlobalModel from "@/model/globalModel";
import { ISearchPage } from "@/types/FmsTypes";
import { DEFAULT_PAGE_SIZE, DEFAULT_FIRST_PAGE_NUM } from "@/utils/constants";
import { useRecordGoodsModel } from "./recordGoodsModel";
import { ISCMSoHistoryDetails } from "./purchasePoTypes";
import { formatNum } from "@/utils/utils";
import { IDescription } from '@/components/YhBox/Types';
import { psiService } from './psiService';
import { convertRes2Blob } from '@/utils/exportFile';

const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }

export function SoTable() {
	const { user: { shopId }, setLoadingInfo, userBranch } = useGlobalModel();
	const {
		goodsRecordModal: { materialCode, code, orderType }
	} = useRecordGoodsModel();

	//列表数据源
	const [dataSource, setDataSource] = useState<ISCMSoHistoryDetails[]>([]);
	//列表数据源分页参数
	const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
	// 销售总数
	const [saleTotal, setSaleTotal] = useState<number>(0)
	const [loading, setLoading] = useState<boolean>(false);
	const [checked, setChecked] = useState(false)
	useEffect(() => {
		loadData();
	}, [])

	const loadData = async (page: ISearchPage = initPgCfg, allCustomerCode?: boolean) => {
		setLoading(true);
		try {
			const searchParams = {
				shopId,
				materialCode,
				orgCode: allCustomerCode || orderType !== 'sale' ? undefined : code,
				types: ['io_usrd', 'io_ssrd', 'io_ssd'],
				pageNum: 1,
				pageSize: 1000
			}
			let total = 0
			let { retData } = await psiService.purchaseSaleHistoryDeatil(searchParams, userBranch);
			const newData = retData.map(item => {
				return {
					...item,
					orderType: item.type === 'io_ssd' ? '销售' : item.type === 'io_ssrd' ? '销退' : '非关联退货',
					// num: item.type === 'io_ssd' ? item.num : -(item.num),
					amount: item.num * item.price ?? 0,
					saleNum: item.type === 'io_ssd' ? item.num : -(item.num)
				}
			})
			newData.forEach(item => {
				total += item.saleNum
			})
			setSaleTotal(total)
			setDataSource(newData ?? []);
			setLoading(false)
		} catch (error) {
			setLoading(false);
			setDataSource([])
		}
	}

	//导出
	const exportDetail = async () => {
		if (!dataSource.length) {
			message.warning("无数据");
			return;
		}
		setLoadingInfo({ loadingVisible: true, txt: "快速导出中" });
		try {
			const searchParams = {
				shopId,
				materialCode: materialCode,
				types: ['io_usrd', 'io_ssrd', 'io_ssd']
			}
			let result = await psiService.purchaseSaleStorageDeatilExport(searchParams);
			result && setLoadingInfo({ loadingVisible: false, txt: "" });
			convertRes2Blob(result);
		}
		catch {
			setLoadingInfo({ loadingVisible: false, txt: "" })
		}
	}

	const action = <>
		{/* <YhAuth resCode={ResourceAuthEnum.ST_DB_EX}> */}
		<Button
			className="mr-5"
			type="link"
			shape="round"
			onClick={() => exportDetail()}
		>导出</Button>
		{/* </YhAuth> */}
	</>;

	const desc: IDescription[] = [
		// {
		// 	label: "销售数量",
		// 	value: saleTotal,
		// 	color: DescriptionColorEnum.red
		// }
	]

	const columns: ColumnsType<ISCMSoHistoryDetails> = [
		{
			title: '序号',
			width: 66,
			align: "center",
			render: (t: any, r: any, i: number) => i + 1
		}, {
			title: '单位名称',
			width: 160,
			align: "center",
			dataIndex: 'orgName',
			render: text => <p className="ellipsis" title={text}>{text}</p>
		}, {
			title: '单据号',
			width: 186,
			align: "center",
			dataIndex: 'code',
		}, {
			title: '单价',
			width: 160,
			align: "center",
			dataIndex: 'price',
			render: text => `￥${formatNum(text)}`
		}, {
			title: '数量',
			width: 120,
			align: "center",
			dataIndex: 'num',
		}, {
			title: '金额',
			width: 120,
			align: "center",
			dataIndex: 'amount',
			render: text => `￥${formatNum(text)}`
		}, {
			title: '折后金额',
			width: 120,
			align: "center",
			dataIndex: 'disAmount',
			render: (text, record) => `￥${formatNum(+record.price * +record.num * (1 - Number(record.discountRate ?? 0)))}`
		}, {
			title: '业务日期',
			width: 180,
			align: "center",
			dataIndex: 'createTime',
		}, {
			title: '出入库日期',
			width: 180,
			align: "center",
			dataIndex: 'stockIoTime',
		}, {
			title: '业务员',
			width: 120,
			align: "center",
			dataIndex: 'createUser',
		}, {
			title: '备注',
			width: 120,
			align: "center",
			dataIndex: 'note',
		}, {
			title: '销售类型',
			width: 80,
			align: "center",
			dataIndex: 'typeName',
		}, {
			title: '优惠类型',
			width: 120,
			align: "center",
			dataIndex: 'preferentialTypeName',
		}, {
			title: '单据类型',
			width: 140,
			align: "center",
			dataIndex: 'orderType',
		}, {
			title: '调拨单号',
			width: 200,
			align: "center",
			dataIndex: 'transferOrder',
		},
	];

	const rightChildren = <Checkbox checked={checked} onChange={(e) => { setChecked(e.target.checked); loadData(initPgCfg, e.target.checked) }}>
		所有单位
	</Checkbox>

	return <YhBox rightChildren={orderType === 'sale' ? rightChildren : <></>} title={action} style={{ marginBottom: "15px" }}>
		<Table
			rowKey={record => record.id}
			loading={loading}
			columns={columns}
			dataSource={dataSource}
			pagination={false}
			scroll={{ x: 'max-content', y: 340 }}
		/>
	</YhBox>
}